import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { RouteSEO } from "@/lib/seo";
import { Toaster } from "sonner";

import { BrandProvider } from "@/context/BrandContext";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";

import Landing from "@/pages/Landing";
import Assessment from "@/pages/Assessment";
import Result from "@/pages/Result";
import Privacy from "@/pages/Privacy";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import LeadDetail from "@/pages/admin/LeadDetail";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminQuestions from "@/pages/admin/AdminQuestions";
import AdminMeetings from "@/pages/admin/AdminMeetings";
import AdminCampaigns from "@/pages/admin/AdminCampaigns";
import Calculators from "@/pages/Calculators";

function App() {
  return (
    <div className="App">
      <BrandProvider>
        <AuthProvider>
          <LanguageProvider>
            <BrowserRouter>
              <RouteSEO />
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/assessment" element={<Assessment />} />
                <Route path="/result/:assessmentId" element={<Result />} />
                <Route path="/calculators" element={<Calculators />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
                <Route path="/admin/leads/:leadId" element={<ProtectedRoute><LeadDetail /></ProtectedRoute>} />
                <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
                <Route path="/admin/questions" element={<ProtectedRoute><AdminQuestions /></ProtectedRoute>} />
                <Route path="/admin/meetings" element={<ProtectedRoute><AdminMeetings /></ProtectedRoute>} />
                <Route path="/admin/campaigns" element={<ProtectedRoute><AdminCampaigns /></ProtectedRoute>} />
              </Routes>
            </BrowserRouter>
          </LanguageProvider>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrandProvider>
    </div>
  );
}

export default App;
